var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',_vm._l((_vm.actionList),function(action){return _c('sui-button',{key:action,attrs:{"content":action},on:{"click":function($event){_vm.buttonAction(action)}}})})),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.student.lastName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.student.firstName))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f1d8616","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/students/StudentTableRow.vue
// module id = null
// module chunks = 